import { render, staticRenderFns } from "./DroppedOrderBanner.vue?vue&type=template&id=2f4708da&lang=pug"
import script from "./DroppedOrderBanner.vue?vue&type=script&lang=ts"
export * from "./DroppedOrderBanner.vue?vue&type=script&lang=ts"
import style0 from "./DroppedOrderBanner.vue?vue&type=style&index=0&id=2f4708da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports